import { cn } from "@babybjorn/ui";
import { motion } from "motion/react";
import {
	useContext,
	type FC,
	type HTMLAttributes,
	type PropsWithChildren,
} from "react";
import { AccordionContext } from "../../Accordion";
import * as s from "./AccordionPanel.module.scss";

type AccordionPanelProps = PropsWithChildren<
	HTMLAttributes<HTMLDivElement> & {
		accordionIndex: string;
		narrow?: boolean;
		fullWidth?: boolean;
	}
>;

const AccordionPanel: FC<AccordionPanelProps> = ({
	accordionIndex,
	children,
	narrow,
	fullWidth,
}) => {
	const [state] = useContext(AccordionContext);

	return (
		<motion.div
			className={cn(s.container, {
				[s.narrow]: narrow,
			})}
			variants={variants}
			initial="closed"
			animate={state[accordionIndex] ? "open" : "closed"}
		>
			<span className={s.divider} />
			<div
				className={cn(s.content, {
					[s.fullWidth]: fullWidth,
				})}
			>
				{children}
			</div>
		</motion.div>
	);
};

export default AccordionPanel;

const variants = {
	closed: {
		display: "block",
		opacity: 0,
		height: 0,
		transition: {
			duration: 0.2,
			opacity: {
				duration: 0.05,
			},
		},
		transitionEnd: { display: "none" },
	},
	open: {
		opacity: 1,
		height: "auto",
		transition: {
			duration: 0.2,
		},
	},
};
